import React from 'react'

import Avatar from 'components_new/atoms/Avatar'
import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'
import Skeleton from 'components_new/atoms/Skeleton'
import Text from 'components_new/atoms/Text'

import { BOARD } from 'components_new/molecules/Node/accents'

import { useSimTable } from 'redux/hooks/SimTables'
import { parseDatetime } from 'utils/dateParser'

/** "14 jul 2026 kl 11:06:00" -> "14 jul 2026 kl 11:06" */
const formatUpdatedAt = (datetime: string) =>
  parseDatetime(datetime).replace(/:\d{2}$/, '')

/** "Jonatan Jönsson" -> "JJ" */
const getInitials = (name: string) =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')

function TableHeader() {
  const table = useSimTable()

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'common.white',
        borderBottom: `1px solid ${BOARD.borderSoft}`,
        display: 'flex',
        gap: 2,
        justifyContent: 'space-between',
        px: 3,
        py: 2
      }}
    >
      <Text
        color="text.primary"
        sx={{
          fontFamily: BOARD.fontDisplay,
          fontSize: '1.5rem',
          fontWeight: 700,
          letterSpacing: '-0.03em',
          lineHeight: 1.1
        }}
      >
        {table ? (
          table.name
        ) : (
          <Skeleton variant="text" width={140} height={34} />
        )}
      </Text>

      {table ? (
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 3 }}>
          <DetailSection title="Senast uppdaterad">
            <Text color="text.primary" variant="body2">
              {table.updated_at ? formatUpdatedAt(table.updated_at) : '–'}
            </Text>
          </DetailSection>

          <Divider flexItem orientation="vertical" />

          <DetailSection title="Uppdaterad av">
            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
              <Avatar
                size="small"
                bgcolor="brand.background"
                sx={{ color: 'common.black', fontSize: '10px' }}
              >
                {getInitials(table.updated_by)}
              </Avatar>
              <Text color="text.primary" variant="body2">
                {table.updated_by}
              </Text>
            </Box>
          </DetailSection>
        </Box>
      ) : null}
    </Box>
  )
}

const DetailSection = (props: { title: string; children: React.ReactNode }) => {
  const { title, children } = props

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}
    >
      <Text
        color="text.secondary"
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          letterSpacing: '0.07em',
          lineHeight: 1,
          textTransform: 'uppercase'
        }}
      >
        {title}
      </Text>
      {children}
    </Box>
  )
}

export default TableHeader
